<template>
  <div class="wrapper">
    <alert-empty-file offset-x></alert-empty-file>
    <alert-cert-expire offset-x></alert-cert-expire>


    <!-- v-if="selectedCompanyProductList?.isApAutomateType?.isSAP" -->
    <!-- {{ selectedCompanyProductList}} -->
    <div v-if="selectedCompanyProductList?.isApAutomate && isApRoute" class="program-bar">
        <div v-if="selectedCompanyProductList?.isApAutomateType == 1" class="sap">
          <img class="tw-h-5" src="/images/icons/sap.png" alt="">
        </div>
        <div v-if="selectedCompanyProductList?.isApAutomateType == 2" class="express">
          <div class="tw-flex tw-gap-1 tw-items-center tw-justify-center">
            <img class="tw-h-5" src="/images/icons/express.png" alt="">
          </div>
        </div>
    </div>
    <div class="app-bar">
      <!-- Branch Selection Menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="branch" v-bind="attrs" v-on="on">
            <div class="name">
              สาขา :
              <span v-if="!selectedBranch">ทั้งหมด</span>
              <span v-if="selectedBranch">{{ selectedBranch }}</span>
            </div>
            <img src="/images/icon-angle-down.svg" alt="dropdown" />
          </div>
        </template>
        <v-list>
          <v-list-item link>
            <v-list-item-title v-on:click="setSelectedBranch('')"
              >ทั้งหมด</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            link
            v-for="branch in branchList"
            :key="branch"
            v-on:click="setSelectedBranch(branch)"
          >
            <v-list-item-title>{{ branch }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Company Selection Menu -->
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <div class="company-name" v-bind="attrs" v-on="on">
            <v-avatar
              size="40"
              color="#F5F5F5"
              class="mr-3 font-24 logoText"
              style="background-color: #fff"
            >
              <img
                v-if="selectedCompany.imageLogoUrl"
                :src="
                  selectedCompany.imageLogoUrl +
                  '=s' +
                  Math.round(40 * getDeviceRatio())
                "
                :alt="selectedCompany.nameTH"
                style="object-fit: contain"
              />
              <span
                v-else-if="selectedCompany.nameEN"
                class="edit-text-avatar"
                >{{ selectedCompany.nameEN[0].toUpperCase() }}</span
              >
            </v-avatar>
            <h3>{{ selectedCompany.nameTH }}</h3>
            <img
              src="/images/icon-angle-down.svg"
              alt="dropdown"
              class="change-company"
            />
          </div>
        </template>
        <v-list>
          <v-list-item
            link
            v-for="company in filteredCompanies"
            :key="company.id"
            :href="`/${getCompanyId(company.id)}/dashboard`"
          >
            <v-avatar
              color="#F5F5F5"
              size="30"
              class="mr-3 logoText"
              style="background-color: #fff"
            >
              <img
                v-if="company.company.imageLogoUrl"
                :src="
                  company.company.imageLogoUrl +
                  '=s' +
                  Math.round(30 * getDeviceRatio())
                "
                :alt="company.company.nameTH"
                style="object-fit: contain"
              />
              <span
                v-else-if="company.company.nameEN"
                class="edit-text-avatar"
                >{{ company.company.nameEN[0].toUpperCase() }}</span
              >
            </v-avatar>
            <v-list-item-title>{{ company.company.nameTH }}</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item link key="add-company" href="/company-add">
            <v-avatar size="30" class="mr-3 logoText">
              <v-icon
                dark
                left
                color="#707070"
                size="20px"
                style="margin-left: 10px"
                >mdi-plus-circle-outline</v-icon
              >
            </v-avatar>
            <v-list-item-title>สร้างบริษัทใหม่</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import AlertEmptyFile from "@/components/admin/documents/alertEmptyFile";
import AlertCertExpire from "@/components/admin/documents/alertCertExpire";

export default {
  name: "AppBar",
  components: {
    AlertEmptyFile,
    AlertCertExpire,
  },
  data() {
    return {
      companyVisibility: {},
    };
  },
  computed: {
    ...mapState({
      companies: (state) => state.companies.list,
      selectedCompany: (state) => state.companies.selectedCompany,
      selectedBranch: (state) => state.companies.selectedBranch,
      branchList: (state) => state.companies.branchList,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
      user: (state) => state.user.userData, // Access the user state
    }),
    STORAGE_KEY() {
      return this.user?.email
        ? `companyVisibilitySettings_${this.user.email}`
        : null;
    },
    filteredCompanies() {
      // If there is no companyVisibility setting, show all companies
      if (!Object.keys(this.companyVisibility).length) return this.companies;

      // Filter companies based on the visibility setting
      return this.companies.filter(
        (company) => this.companyVisibility[company.id] !== false
      );
    },
    isApRoute() {
      return this.$route.path.includes('accountspayable');
    },
  },
  created() {
    this.getCompanyList();
    this.getBranchList();
    this.setCompany();
    this.getCompanyStatus();
    if (this.STORAGE_KEY) {
      this.initializeVisibilitySettings();
    }
  },
  watch: {
    STORAGE_KEY(newKey) {
      if (newKey) {
        this.initializeVisibilitySettings();
      }
    },
  },

  methods: {
    getDeviceRatio() {
      return window.devicePixelRatio;
    },
    getCompanyId(companies_user_id) {
      if (companies_user_id) {
        return companies_user_id.split("_")[0];
      }
    },
    getCompanyList() {
      this.$store.dispatch("companies/getList");
    },
    getBranchList() {
      let companyId = this.$route.params.companyId;
      if (companyId) {
        this.$store.dispatch("companies/getBranchList", { companyId });
      }
    },
    setSelectedBranch(branch) {
      this.$store.dispatch("companies/setSelectedBranch", { branch });
    },
    setCompany() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("companies/setCompany", { companyId });
    },
    getCompanyStatus() {
      let companyId = this.$route.params.companyId;
      this.$store.dispatch("statusesByCompany/getStatus", { companyId });
    },
    getURLPath() {
      let url = this.$route.path;
      let pathList = url.split("/");
      return pathList.filter((e, i) => i > 1).join("/");
    },
    initializeVisibilitySettings() {
      // Load settings from localStorage using user-specific key
      if (this.STORAGE_KEY) {
        const savedSettings = localStorage.getItem(this.STORAGE_KEY);
        if (savedSettings) {
          this.companyVisibility = JSON.parse(savedSettings);
        } else {
          // Default to showing all companies if no settings are found
          this.companyVisibility = {};
        }
      }
    },
  },
};
</script>

<style lang="css" scoped>
.wrapper {
  height: 98px;
}

.app-bar {
  background: #ffffff;
  width: 590px;
  height: 80px;
  position: absolute;
  right: 0;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border-bottom-left-radius: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  user-select: none;
}

.branch {
  cursor: pointer;
  display: flex;
  align-items: center;
  border-right: #c4c4c4 1px solid;
  height: 60px;
  padding-right: 20px;
  margin: 20px;
}

.branch .name {
  margin-right: 10px;
}

.branch img {
  margin-left: 10px;
}

.company-name {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.company-name .change-company {
  position: absolute;
  right: 21px;
}

.company-name h3 {
  margin: 0;
}

.logoText {
  font-weight: bold;
}

.edit-text-avatar {
  margin-top: 3px;
  margin-left: -1px;
}

.font-24 {
  font-size: 24px;
}

.program-bar {
  border-radius: 0 0 18px  18px;
  text-align: center;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  width: 100px;
  height: 50px;
  position: absolute;
  overflow: clip;
  right: 620px;
}

.program-bar .sap {
  border-top: 5px solid rgb(240, 176, 0);
  color: orange;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 1rem;
  font-weight: bolder;
}

.program-bar .express {
  border-top: 5px solid rgb(189, 0, 0);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  font-size: 1rem;
  font-weight: bolder;
}

@media screen and (max-width: 480px) {
  .wrapper .app-bar {
    width: 100vw;
  }
}
</style>
